
<template>
<div>
    <a-modal
      :title="modalState.title"
      :visible="modalState.isShow"
     :confirm-loading="confirmLoading"
     width="580px"
      @cancel="handleCancel"
    >
    <a-input-group compact style="margin-bottom:10px;">
      <a-input-search style="width: 50%" default-value="" :id="currentAppSelectSearchInput"  @search="onSearch" />
    </a-input-group>

     <a-table
      :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange ,type:modalState.rowsType,getCheckboxProps:getCheckboxProps}"
      :columns="columns"
      :data-source="list"
      rowKey="domain"
      :pagination="false"
    />

    <br />

    <a-pagination v-model="pagination.current" :total="pagination.total" @change="handlePageChange" style="float:right;" show-less-items />
    <br />

     <template slot="footer">
        <a-button key="back" @click="handleCancel">
          取消
        </a-button>
        <a-button key="submit" type="primary" :loading="confirmLoading" @click="handleOk">
          确定
        </a-button>
      </template>
    </a-modal>
  </div>
  
</template>
<script>

const columns = [
    {
        title: '域名',
        dataIndex: 'domain',
        align: 'center',
    },
    {
        title: '域名描述',
        dataIndex: 'domaindesc',
        align: 'center',
    },
];

export default {
    data() {
        return {
            confirmLoading: false,
            columns:columns,
            selectedRowKeys: [],
            list:[],
            searchVal:'',
            pagination:{
                total:0,
                pageSize:10,
                current:1,
            },
            originData:[],
            savedPages:[],
            getCheckboxProps: record => ({
                props: {
                    disabled: this.modalState.filterDomain.indexOf(record.domain) != -1, // Column configuration not to be checked
                }
            }),
            currentAppSelectSearchInput:'currentAppSelectSearchInput'
        }
    },
    computed: {
        hasSelected() {
            return this.selectedRowKeys.length > 0;
        },
    },
    props:{
        modalState:{
            isShow:false,
            rowsType:'checkbox',
            selectkeys:undefined,
            filterDomain:[],
        }
    },
    methods: {
        handlePageChange(params_page){
            this.onModalInit(params_page)
        },
        onModalInit(pageNum){
            let that = this;
            let c_params = {
                pageSize:that.pagination.pageSize,
                page:pageNum,
                domain:that.searchVal,
                urlparams:false,
            }
            
            that.$store.dispatch({
                type: "sys/selectDomainUrl",
                params:c_params,
                showMsg: false
            }).then((res)=>{
                if(res.data.success == 1){
                    if(that.modalState.selectkeys){
                        that.selectedRowKeys = that.modalState.selectkeys
                    }
                    let result = res.data.data;
                    that.originData = that.originData.concat(result.list)
                    that.list = result.list;
                    that.pagination.total = result.totalRecords;
                    that.pagination.pageSize = result.pageSize;
                    that.pagination.current = result.page;
                }
                else{
                    that.message.error('获取域名列表失败')
                }
            })
        },

        onSearch(value){
            this.searchVal = value;
            this.onModalInit(); 
        },
        onSelectChange(selectedRowKeys) {
            this.selectedRowKeys = selectedRowKeys;
        },
        handleOk(){
            let current_keys = this.selectedRowKeys;
            let result = [];
            for (let index = 0; index < current_keys.length; index++) {
                const element = current_keys[index];
                let c_item = this.originData.filter(function(n){
                    return element == n.domain
                });
                if(c_item.length == 0){
                    result = undefined
                    console.log("未找到对应数据")
                    break;
                }
                result.push(c_item[0])
            }
            this.$emit('onModalHide',result);
            this.selectedRowKeys = [];
        },
        handleCancel(e) {
            e.preventDefault()
            this.$emit('onModalHide',undefined);
        }
    },
    mounted() {
    },
    watch:{
        'modalState.isShow'(newVal){
            if(newVal){
                setTimeout(() => {
                    document.getElementById('currentAppSelectSearchInput').focus()
                }, 500);
                this.onModalInit(1);
            }
        }
    }
};
</script>

<style scoped>
.ant-form-inline .ant-form-item{
    margin-right:40px;
}
</style>
